import React from 'react';

interface WaveShapeProps {
  position?: 'top' | 'bottom';
  className?: string;
}

export function WaveShape({ position = 'bottom', className }: WaveShapeProps) {
  const positionClass = position === 'top' ? 'top-0' : 'bottom-0';
  const transformClass = position === 'top' ? 'transform rotate-180' : '';

  return (
    <div
      className={`absolute left-0 w-full overflow-hidden leading-[0] ${positionClass} ${transformClass} ${className}`}
      data-negative={position === 'bottom' ? 'true' : undefined}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1000 100"
        preserveAspectRatio="none"
        className="relative block h-[55px] w-[calc(100%+1.3px)] fill-white dark:fill-black"
      >
        <path
          d="M790.5,93.1c-59.3-5.3-116.8-18-192.6-50c-29.6-12.7-76.9-31-100.5-35.9c-23.6-4.9-52.6-7.8-75.5-5.3c-10.2,1.1-22.6,1.4-50.1,7.4c-27.2,6.3-58.2,16.6-79.4,24.7c-41.3,15.9-94.9,21.9-134,22.6C72,58.2,0,25.8,0,25.8V100h1000V65.3c0,0-51.5,19.4-106.2,25.7C839.5,97,814.1,95.2,790.5,93.1z"
        ></path>
      </svg>
    </div>
  );
}
